import { RemoteSolicitation } from "../../../../data/usecases/solicitation/remote-solicitation";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteSolicitation = (): RemoteSolicitation =>
  new RemoteSolicitation(
    "/solicitations",
    makeAxiosHttpClient(),
    settings.API_URL
  );
